import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
} from '../../components/index';
import {
  doGet,
}
  from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import FiltroConsultaCpf from './FiltroConsultaCpf';

class ConsultaCpf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRequerimentosFiltrada: null,
      listaRequerimentosIndexada: [],
      requerimentoVindoDoRequest: null,
      showNoContent: false,
      listaRequerimentosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
    };
  }

  componentDidMount() {
    if (!sessionStorage.getItem('filtroPesquisa')) {
      this.realizaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'requerimento-por-cpf',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRequerimentosIndexada: [], listaRequerimentosIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {
    };
    if (atributosPesquisa.cpf) {
      atributos = { ...atributos, cpf: atributosPesquisa.cpf };
    }
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: [],
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: response.data,
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRequerimentosFiltrada) => {
    this.setState({ listaRequerimentosFiltrada, listaRequerimentosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Não econtrado requerimento para este CPF.',
            noContentSecondaryMessage: 'Informe CPF Válido.',
          });
        } else {
          this.setState({
            showNoContent: false,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  handleClickNovoEstadoFail = () => {
    this.realizaConsulta();
  }
  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )
  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }


  colunasDefault = [{
    id: 'matricula',
    label: 'Matrícula',
  }, {
    id: 'solicitante',
    label: 'Solicitante',
  }, {
    id: 'destinatario',
    label: 'Destinatário',
  }, {
    id: 'tipoRequerimento',
    label: 'Tipo',
    dataFormat: this.addTipoRequerimentoLabel,
  }, {
    id: 'estado',
    label: 'Estado',
    dataFormat: this.addTipoEstadoLabel,
  }, {
    id: 'dataIngresso',
    label: 'Data de Ingresso',
  }, {
    id: 'dataDesvinculacao',
    label: 'Data de Desvinculação',
  }];


  montaColunas = () => {
    const requerimentosPorCpfTableHeader = this.colunasDefault.slice();
    return requerimentosPorCpfTableHeader;
  }

   defineListaParaTabela = () => {
     if (this.state.listaRequerimentosFiltrada !== null) {
       return this.state.listaRequerimentosFiltrada;
     }
     return this.state.listaRequerimentosIndexada;
   }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }
  montaTituloTabela = () => ('Requerimentos')

  render() {
    const options = {
      noDataText: 'Nenhum requerimento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };

    const requerimentosPorCpfTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroConsultaCpf
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            list={this.state.listaRequerimentosIndexada}
            listaRequerimentosIndexadaAtualizada={this.state.listaRequerimentosIndexadaAtualizada}
          />
          <Table
            legend={this.montaTituloTabela()}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={requerimentosPorCpfTableHeader}
            pagination
            remote
          />
        </DtpContentContainer>
      )
    );
  }
}

ConsultaCpf.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default ConsultaCpf;



// WEBPACK FOOTER //
// ./src/pages/consulta-cpf/ConsultaCpf.jsx